import { Image } from "antd-mobile";
import { useTranslation } from "react-i18next";
import { CustomTable } from "../../../../../../../components";

import { useGetOpenedGameCategory } from "../../../../../../../hooks/category.hooks";
import { moneyFormat } from "../../../../../../../plugins/numberFormat";
import { envChangeType } from "../../../../../../../plugins/utils";
import { useGetAgentRebateLevel } from "../../../../hooks/comissionreport.hooks";
import TitleContainer from "../TitleContainer";
import styles from "./style.module.scss";
import "./style.scss";

const BetRebate = () => {
  const { t } = useTranslation();

  const { data: agentLevels } = useGetAgentRebateLevel({});

  const { data: categoryList } = useGetOpenedGameCategory({});

  const columns_category = [
    {
      title: t("comission.category.level"),
      width: 100,
      align: "center",
      dataIndex: "name",
      render: (text, record, index) => <>{`LV${index + 1}`}</>,
    },

    {
      title: t("comission.category.tier1"),
      width: 100,
      align: "center",
      dataIndex: "level_1",
      render: (text, record, index) => (
        <>{`${moneyFormat(record.level_1 * 100, 0, 5, "", ".")}%`}</>
      ),
    },
    {
      title: t("comission.category.tier2"),
      width: 100,
      align: "center",
      dataIndex: "level_2",
      render: (text, record, index) => (
        <>{`${moneyFormat(record.level_2 * 100, 0, 5, "", ".")}%`}</>
      ),
    },
    {
      title: t("comission.category.tier3"),
      width: 100,
      align: "center",
      dataIndex: "level_3",
      render: (text, record, index) => (
        <>{`${moneyFormat(record.level_3 * 100, 0, 5, "", ".")}%`}</>
      ),
    },

    {
      title: t("comission.category.tier4"),
      width: 100,
      align: "center",
      dataIndex: "level_4",
      render: (text, record, index) => (
        <>{`${moneyFormat(record.level_4 * 100, 0, 5, "", ".")}%`}</>
      ),
    },
  ];

  const columns_level = [
    {
      title: t("betamount.rebate.agentlevel"),
      width: 100,
      align: "center",
      dataIndex: "name",
    },

    {
      title: t("betamount.rebate.invitecount"),
      width: 100,
      align: "center",
      dataIndex: "total_invite",
    },
    {
      title: t("betamount.rebate.betsum"),
      width: 120,
      align: "center",
      dataIndex: "total_bet",
      render: (text, record, index) => <>{moneyFormat(text)}</>,
    },
    {
      title: t("betamount.rebate.depositsum"),
      width: 120,
      align: "center",
      dataIndex: "total_recharge",
      render: (text, record, index) => <>{moneyFormat(text)}</>,
    },
  ];

  const renderLevelBadge = () => {
    if (agentLevels) {
      return (
        <div className={styles.badgeContainer}>
          {agentLevels.map((level) => {
            return (
              <div className={styles.badgeItemContainer} key={level.name}>
                <Image
                  className={styles.image}
                  src={`/images/comission/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/levels/badge_${level.name}.png`}
                  fallback={
                    <Image
                      src={`/images/comission/default/levels/badge_${level.name}.png`}
                      placeholder={false}
                    />
                  }
                />
                <div className={styles.badgeTitle}>
                  {t([
                    `badge.name.${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}.${level.name}`,
                    `badge.name.${level.name}`,
                  ])}
                </div>
              </div>
            );
          })}
        </div>
      );
    }
    return null;
  };

  const renderCategory = () => {
    if (categoryList) {
      return categoryList?.map((category) => {
        const _category = agentLevels?.map((level) => {
          const currentCategoryData = level?.rebate_data.find(
            (data) => data.game_category_code === category.game_category_code,
          );
          return currentCategoryData;
        });
        return (
          <div key={category.game_category_code}>
            <div className={styles.categoryTitle}>
              {t(`game.category.${category.game_category_code}`)}
            </div>
            <div>
              <CustomTable
                key={"game_category_code"}
                customClass="bet-amount-table"
                columns={columns_category}
                dataSource={_category}
                showInifineScroll={false}
              />
            </div>
          </div>
        );
      });
    }

    return null;
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.contentShadow}>
          <div
            className={styles.title1}
            dangerouslySetInnerHTML={{ __html: t("comission.betamount.title1") }}
          />
          <div className={styles.title2}>{t("comission.betamount.title2")}</div>
        </div>
        <div className={styles.content}>
          <div
            className={styles.title1}
            dangerouslySetInnerHTML={{ __html: t("comission.betamount.title1") }}
          />
          <div className={styles.title2}>{t("comission.betamount.title2")}</div>
        </div>

        <Image
          className={styles.background}
          src={`/images/comission/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/header.png`}
          fallback={
            <Image
              src={`/images/comission/default/header.png`}
              className={styles.background}
              placeholder={false}
            />
          }
        />
      </div>
      <div className={styles.card}>
        <TitleContainer title={t("comission.ruledesc.title")} />
        <div className={styles.contentDesc}>
          <div className={styles.ruleSubtitle}>
            {t("comission.ruledesc.subtitle1")}
            <br />
            <span className={styles.red}>{t("comission.ruledesc.subtitle2")}</span>
          </div>
          <div className={styles.ruleContent}>{t("comission.ruledesc.content")}</div>
          <Image
            src={`/images/comission/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/ruleImage.png`}
            fallback={<Image src={`/images/comission/default/ruleImage.png`} placeholder={false} />}
          />
        </div>
      </div>

      <div className={styles.card}>
        <TitleContainer title={t("comission.agentlevel.title")} />
        <div className={`${styles.contentDesc} ${styles.level}`}>
          <div>
            <CustomTable
              key={"id"}
              customClass="bet-amount-table"
              columns={columns_level}
              dataSource={agentLevels || []}
              showInifineScroll={false}
            />
          </div>

          <div className={styles.ruleContent}>{t("comission.leveldesc")}</div>
          <div className={styles.levelBadgeTitle}>{t("comission.level.badge.title")}</div>
          {renderLevelBadge()}
        </div>
      </div>

      <div className={styles.card}>
        <TitleContainer title={t("comission.ratio.title")} />
        <div className={`${styles.contentDesc} ${styles.level}`}>{renderCategory()}</div>
      </div>
    </div>
  );
};

export default BetRebate;
